export function getStatsPath() {
  return '/statistik'
}
